/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_RainInputs */

const en_ui_weather_rain = /** @type {(inputs: Ui_Weather_RainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rain`)
};

const de_ui_weather_rain = /** @type {(inputs: Ui_Weather_RainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regen`)
};

/**
* | output |
* | --- |
* | "Rain" |
*
* @param {Ui_Weather_RainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_rain = /** @type {((inputs?: Ui_Weather_RainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_RainInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_rain(inputs)
	return de_ui_weather_rain(inputs)
});